'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _time = require('./time');

var _time2 = _interopRequireDefault(_time);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var currentLanguage = function currentLanguage(arg) {
  var deviceLang = typeof arg === 'string' ? arg : arg.language;
  if (deviceLang.length === 2) {
    return _time2.default.supportLocale(deviceLang) ? deviceLang : 'en';
  }
  // ISO-639-2 to ISO-639-1 conversion for Android
  switch (deviceLang) {
    case 'ita':
      return 'it';
    case 'eng':
      return 'en';
    case 'fra':
      return 'fr';
    case 'fre':
      return 'fr';
    case 'ger':
      return 'de';
    case 'deu':
      return 'de';
    case 'jpn':
      return 'ja';
    case 'spa':
      return 'es';
    case 'dut':
      return 'nl';
    case 'nld':
      return 'nl';

    default:
      return 'en';

  }
}; // @flow

var formatPrice = function formatPrice(priceInCents) {
  var currencySymbol = '€';
  var price = priceInCents / 100;
  return (currencySymbol + ' ' + price.toFixed(2)).replace('.', ',');
};

exports.default = { currentLanguage: currentLanguage, formatPrice: formatPrice };


//////////////////
// WEBPACK FOOTER
// ./~/@arreeba/ristoranti-frontend-lib/lib/helpers/i18n.js
// module id = 16
// module chunks = 0